export let SAVE_PRICE = 'save-price';
export let SEARCH_CUSTOMER_RESULT = 'search-customer-results';
export let PRICE_FIELD_PREFIX = 'price-field-';
export let CUSTOMER_SEARCH_INPUT = 'customer-search-input';
export const CUSTOMER_SEARCH = 'customer-search';
export const CURRENCY_SELECT = 'currency-select';
